import React, { useState, useEffect } from "react";
import Input from "../../atoms/Input/Input";
import { useLocation, useNavigate } from 'react-router-dom';
import { DateTimeHelper } from '../../../helpers/DateTimeHelper';
import FormCountryCodes from "./FormCountryCodes";
import useRequest from "../../../context/useRequest";

const TripDetailsForm = () => {

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { data: isTravelerData, sendRequest } = useRequest();
  const { data: isprocessBookingData, sendRequest: processBookingRequest } = useRequest();
  const { bookingToken } = location.state;
  const [paymentMethodSelected, setPaymentMethodSelected] = useState(false);
  const [isDataProcessed, setIsDataProcessed] = useState(false);
  const [isTripDetails, setIsTripDetails] = useState({
    title: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    country_code: '',
    trip_t_c: false,
  })

  const [showModal, setShowModal] = useState(false);
  const [isFieldErrors, setIsFieldErrors] = useState({})
  // const [isprocessBooking, setIsProcessBooking] = useState({})
  // console.log(isprocessBooking)
  const [selectedPG, setSelectedPG] = useState({
    code: "",
    name: "",
    convenience_type: "flat",
    convenience_value: 0,
    actual_convenience_value: 0
  });


  useEffect(() => {
    if (isTravelerData && isTravelerData.data) {
      setIsTripDetails((prev) => {
        return JSON.stringify(prev) === JSON.stringify(isTravelerData.data) ? prev : { ...prev, ...isTravelerData.data };
      });
    }
  }, [isTravelerData]);
  useEffect(() => {
    if (isprocessBookingData && isprocessBookingData.data && !isDataProcessed) {
      setIsDataProcessed(true);
      setIsTripDetails((prev) => ({
        ...prev,
        ...isprocessBookingData.data,
      }));
    }
  }, [isprocessBookingData, isDataProcessed]);

  const tripDetailsHandler = (e) => {
    const { name, type, value, checked } = e.target;
    setIsTripDetails((prev) => ({
      ...prev,
      // [name]: value || "",
      [name]: type === "checkbox" ? checked : value,  // Fix for checkbox handling
    }));
    setIsFieldErrors((prev) => ({
      ...prev,
      [name]: " ",
    }));

    // // Clear error when checkbox is checked
    // if (name === "trip_t_c") {
    //   setIsFieldErrors((prev) => ({
    //     ...prev,
    //     trip_t_c: checked ? "" : prev.trip_t_c,
    //   }));
    // }
  };

  const handleCloseModal = () => {
    console.log('Modal closing and resetting form');

    setShowModal(false);
    // setIsTripDetails({
    //   title: '',
    //   first_name: '',
    //   last_name: '',
    //   email: '',
    //   phone: '',
    //   country_code: '',
    // });
    setIsFieldErrors({});
  }
    const tripSubmitHandler = async (e) => {
      e.preventDefault();

      const formTraveler = new FormData();
      formTraveler.append("title", isTripDetails.title);
      formTraveler.append("first_name", isTripDetails.first_name);
      formTraveler.append("last_name", isTripDetails.last_name);
      formTraveler.append("email", isTripDetails.email);
      formTraveler.append("country_code", isTripDetails.country_code);
      formTraveler.append("phone", isTripDetails.phone);
      formTraveler.append("booking_token", bookingToken);

      try {
        const response = await sendRequest({
          method: "POST",
          url: "/cab/createBooking",
          body: formTraveler,
        });

        if (response.status == true && isTripDetails.trip_t_c) {
          setShowModal(true);
        } else {
          if (response?.errors) {
            setIsFieldErrors(response?.errors);
            if (!isTripDetails.trip_t_c) {
              setIsFieldErrors((prev) => ({
                ...prev,
                trip_t_c: "You must agree to the Terms and Conditions",
              }));
            }
          } else if (!isTripDetails.trip_t_c) {
            setIsFieldErrors((prev) => ({
              ...prev,
              trip_t_c: "You must agree to the Terms and Conditions",
            }));
          } else {
            navigate("/booking-response", { state: { serverResponse: response } })
          }
        }
      } catch (errorMessage) {
        console.log(errorMessage);
        alert("An unexpected error occurred. Please try again.");

        setIsFieldErrors({ message: "Something went wrong. Please try again." });
      }

    }

  const handlePGChange = (paymentMethod, baseFare) => {
    if (paymentMethod) {
      if ("code" in paymentMethod && "name" in paymentMethod && "convenience_type" in paymentMethod && "convenience_value" in paymentMethod) {

        paymentMethod.convenience_value = parseFloat(paymentMethod.convenience_value);

        let act_convenience_value = paymentMethod.convenience_value;

        if (paymentMethod.convenience_type == "percentage") {
          act_convenience_value = paymentMethod.convenience_value * baseFare / 100;
        }

        const tempSelectedPG = {
          code: paymentMethod.code,
          name: paymentMethod.name,
          convenience_type: paymentMethod.convenience_type,
          convenience_value: paymentMethod.convenience_value,
          actual_convenience_value: act_convenience_value
        }

        setSelectedPG(tempSelectedPG);
        setPaymentMethodSelected(true);
      }
    } else {
      setPaymentMethodSelected(false);
    }

  }

  const handlePayment = async () => {

    const paymentToken = isTravelerData?.data?.payment_token || 0;

    const loadScript = (onLoadCallback) => {

      const src = `${baseURL}/payment/paymentJsLib`;


      if (document.querySelector(`script[src="${src}"]`)) {
        console.log('Script already loaded');
        onLoadCallback();
        return;
      }
      const script = document.createElement('script');
      script.src = src;
      script.async = true;

      script.onload = () => {
        console.log('Script loaded successfully');
        if (typeof window.CustomPaymentGateway !== "function") {
          alert("Payment gateway library failed to load.");
          return;
        }
        onLoadCallback();

      };

      script.onerror = () => {
        console.error('Failed to load the Payment Gateway script');
        alert("There was an error loading the payment gateway. Please try again later.");
      };

      document.body.appendChild(script);
    };

    const paynow = () => {
      const config = {
        paymentToken,
        paymentGateway: selectedPG.code,
        handleResponse: async (response) => {
          console.log('Received response:', response);

          try {
            const formPayment = new FormData();
            formPayment.append("payment_token", paymentToken);

            const serverResponse = await processBookingRequest({
              method: "POST",
              url: "/cab/processBooking",
              body: formPayment,
            });


            navigate("/booking-response", { state: { serverResponse: serverResponse } });

          } catch (error) {
            console.error("Error processing payment:", error);
            setIsFieldErrors({ message: "An error occurred while processing your payment. Please try again later." });
          }

        },
      };
      const payment = new window.CustomPaymentGateway(config);
      payment.openPaymentWindow();

    }

    loadScript(paynow);
  };


  return (
    <section className="confirm-section--tripDetails">
      <h3 className="h4 mb-3">Traveler Information</h3>
      <form onSubmit={tripSubmitHandler} className="confirm-section--tripDetails-form ">


        <div className="confirm-section--tripDetails-form-itemTwo">
          <div className="input-group w-100 ">
            <label>Select Title  <span style={{ color: "red" }}>*</span></label>
            <select
              className="name_title"
              name="title"
              value={isTripDetails.title}
              onChange={tripDetailsHandler}
            >
              <option>Please select</option>
              <option value="Mr">Mr</option>
              <option value="Ms">Ms</option>
              <option value="Mrs">Mrs</option>
            </select>
            {isFieldErrors.title && (
              <p className="error-message">{isFieldErrors.title}</p>
            )}

          </div>
          <div className="input-group ">
            <Input
              type="text"
              name="first_name"
              placeholder="First Name"
              value={isTripDetails.first_name}
              onChange={tripDetailsHandler}
              className="form-control"

              label={
                <span>
                  First Name  <span style={{ color: "red" }}>*</span>
                </span>

              }

            />
            {isFieldErrors.first_name && (
              <p className="error-message">{isFieldErrors.first_name}</p>
            )}
          </div>
          <div className="input-group ">
            <Input
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={isTripDetails.last_name}
              onChange={tripDetailsHandler}
              className="form-control"

              label={
                <span>
                  Last Name  <span style={{ color: "red" }}>*</span>
                </span>

              }
            />
            {isFieldErrors.last_name && (
              <p className="error-message">{isFieldErrors.last_name}</p>
            )}
          </div>
          <div className="input-group w-100">
            <Input
              type="email"
              name="email"
              placeholder="Email"
              value={isTripDetails.email}
              onChange={tripDetailsHandler}
              className="form-control"
              label={
                <span>
                  Email  <span style={{ color: "red" }}>*</span>
                </span>

              }
            />
            {isFieldErrors.email && (
              <p className="error-message">{isFieldErrors.email}</p>
            )}
          </div>
          <div className="input-group ">
            <FormCountryCodes
              name="country_code"
              value={isTripDetails.country_code}
              onChange={tripDetailsHandler}
            />
            {isFieldErrors.country_code && (
              <p className="error-message">{isFieldErrors.country_code}</p>
            )}
          </div>

          <div className="input-group ">
            <Input
              type="text"
              name="phone"
              placeholder="Contact Number"
              value={isTripDetails.phone}
              onChange={tripDetailsHandler}
              className="form-control"
              label={
                <span>
                  Contact Number  <span style={{ color: "red" }}>*</span>
                </span>

              }
            />
            {isFieldErrors.phone && (
              <p className="error-message">{isFieldErrors.phone}</p>
            )}
          </div>


          {/* <div className="input-group">
            <Input
              type="checkbox"
              id="terms"
              name="trip_t_c"
              checked={isTripDetails.trip_t_c}
              onChange={tripDetailsHandler}
            >
              I agree to the <a href="/terms">Terms and Conditions</a> <span style={{ color: "red" }}>*</span>
            </Input>
            {isFieldErrors.trip_t_c && <p className="error-message">{isFieldErrors.trip_t_c}</p>}
          </div> */}

          <div className="mb-3">
            <Input
              type="checkbox"
              id="terms"
              name="trip_t_c"
              checked={isTripDetails.trip_t_c}
              onChange={tripDetailsHandler}
            >
            </Input>
            {isFieldErrors.trip_t_c && <p className="error-message" style={{ color: "red", marginTop: "5px" }}>
              {isFieldErrors.trip_t_c}
            </p>}
          </div>
          <div className="input-group submit">
            <button type="submit" className="btn-custom"  >Submit</button>
          </div>
        </div>
      </form>

      <div className={`modal ${showModal ? "d-block" : "d-none"} Confirmation-modal-show`} tabIndex="-1">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <div>
                <h5 className="modal-title">Booking Confirmation</h5>
                <p>Below are the details of your booking</p>
              </div>
              <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
            </div>
            <div className="modal-body">
              <div className="booking-information">
                <div className="payment-section">
                  <h5 className="h4">Itinerary Information</h5>
                  <ul>

                    <li><span>Reference Id:</span> {isTravelerData?.data?.["booking-detail"]["reference_id"]}</li>
                    <li><span>Pickup Location:</span> {isTravelerData?.data?.["booking-detail"]["pickup_location"]}</li>
                    <li><span>Drop Location:</span> {isTravelerData?.data?.["booking-detail"]["drop_location"]}</li>
                    <li><span>Pickup Date & Time:</span> {DateTimeHelper(isTravelerData?.data?.["booking-detail"]["pickup_date"], isTravelerData?.data?.["booking-detail"]["pickup_time"])}</li>
                    <li><span>Vehicle Type:</span> {isTravelerData?.data?.["itinerary-detail"]["vehicle_category"]}, {isTravelerData?.data?.["itinerary-detail"]["vehicle_brand"]}</li>
                    <li><span>Vehicle Model :</span> {isTravelerData?.data?.["itinerary-detail"]["vehicle_model"]}</li>
                  </ul>
                </div>
                <div className="payment-section">
                  <h5 className="h4">Traveler Information</h5>
                  <ul>
                    <li><span>Full Name:</span> {isTravelerData?.data?.["traveller-detail"]["title"]} {isTravelerData?.data?.["traveller-detail"]["first_name"]} {isTravelerData?.data?.["traveller-detail"]["last_name"]}</li>
                    <li><span>Email:</span> {isTravelerData?.data?.["traveller-detail"]["email"]}</li>
                    {/* <li><span>Country Code:</span> {isTravelerData?.data?.["traveller-detail"]["country_code"]}</li> */}
                    <li><span>Phone No:</span> {isTravelerData?.data?.["traveller-detail"]["phone"]}</li>
                  </ul>
                </div>
                <div className="payment-section payment-gateway-container">
                  <h5 className="h4 pb-2 text-color-green">Choose Payment Method</h5>
                  <div className="confirm-section--payment--top-label mb-4">
                    {isTravelerData?.data?.paymentGateway?.map((paymentMethod, index) => (
                      <label key={index} className="d-flex align-items-start mb-2">
                        <input
                          type="radio"
                          id={paymentMethod.code}
                          name="payment"
                          value={paymentMethod.code}
                          onChange={() => handlePGChange(paymentMethod, (isTravelerData?.data?.["transaction-detail"]["base_fare"] + isTravelerData?.data?.["transaction-detail"]["charges"]))}
                        />
                        {paymentMethod.name}
                      </label>
                    ))}
                  </div>
                </div>

              </div>
              <div className="payment-information">
                <div className="confirm-section--payment-fare mt-0">
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h4 className="h6 mb-0">Base Price</h4>
                  </div>
                  <div className="confirm-section--payment-fare-makeFlex">

                    <h3 className="h6 mb-0"> ₹{isTravelerData?.data?.["transaction-detail"]["base_fare"] || 0}</h3>
                  </div>
                </div>
                <div className="confirm-section--payment-fare">
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h4 className="h6 mb-0">Taxes Price</h4>
                  </div>
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h3 className="h6 mb-0"> ₹{isTravelerData?.data?.["transaction-detail"]["charges"]}</h3>
                  </div>
                </div>
                <div className="confirm-section--payment-fare">
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h4 className="h6 mb-0">Discount</h4>
                  </div>
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h3 className="h6 mb-0"> ₹{isTravelerData?.data?.["transaction-detail"]["discount"]}</h3>
                  </div>
                </div>
                <div className="confirm-section--payment-fare">
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h4 className="h6 mb-0">Convenience Fee</h4>
                  </div>
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h3 className="h6 mb-0"> ₹{selectedPG.actual_convenience_value || 0}</h3>
                  </div>
                </div>
                <div className="confirm-section--payment-total mt-4 pt-4">
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h4 className="h3 mb-0">Total</h4>
                    <p className="mb-0">inc. of tolls and taxes</p>
                  </div>
                  <div className="confirm-section--payment-fare-makeFlex">
                    <h4 className="h3 mb-0">₹{
                      (isTravelerData?.data?.["transaction-detail"]["base_fare"] || 0) +
                      (isTravelerData?.data?.["transaction-detail"]["charges"] || 0) -
                      (isTravelerData?.data?.["transaction-detail"]["discount"] || 0) +
                      selectedPG.actual_convenience_value
                    }
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className={`btn btn-custom me-3`}
                onClick={handlePayment}
                disabled={!paymentMethodSelected}
              >
                Confirm Booking
              </button>
              <button type="button" className="btn bth-close" onClick={handleCloseModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
};

export default TripDetailsForm